import { assertIsPositiveInteger } from './assertions';

export default class PositiveInteger {
	public get value(): number {
		return this.#value;
	}

	#value: number;
	public constructor(value: number) {
		assertIsPositiveInteger(value);
		this.#value = value;
	}
}
